import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\projects\\ups-updated-2026\\components\\Gallery.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\projects\\ups-updated-2026\\components\\InnerBanner.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\projects\\ups-updated-2026\\components\\service\\Services.jsx");
